<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new file</small>
      </legend>

      <div>
        <form @submit.prevent="newFile()">
          <div class="row">
            <div class="col-md-3">
              <input type="hidden" class="customer_id" :value="Customer.id" />
              <div class="form-group">
                <label>File Code</label>
                <input
                  type="text"
                  class="form-control file_code input-rounded f-s-14"
                  placeholder="file code"
                  :value="Filenumber"
                  required
                  readonly
                />
              </div>

              <div class="form-group">
                <label>
                  Movement
                  <span class="text-danger">*</span>
                </label>
                <select name="file_mov" class="form-control file_mov input-rounded f-s-14">
                  <option value>Select movement</option>
                  <option value="IMPORT" selected="selected">IMPORT</option>
                  <option value="EXPORT">EXPORT</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Cargo status
                  <span class="text-danger">*</span>
                </label>
                <select name="cargo_status" class="form-control cargo_status input-rounded f-s-14">
                  <option value>Select cargo status</option>
                  <option value="DRY">DRY</option>
                  <option value="REEFER">REEFER</option>
                  <option value="DANGEROUS">DANGEROUS</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Eta
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control eta input-rounded f-s-14"
                  placeholder="expected time arrival"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Remarks
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control remarks input-rounded f-s-14"
                  placeholder="file remarks"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>File ref</label>
                <input
                  type="text"
                  class="form-control file_ref input-rounded f-s-14"
                  placeholder="file reference"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Received date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control received_date input-rounded f-s-14"
                  placeholder="file received date"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Shipping line
                  <span class="text-danger">*</span>
                </label>
                <select class="form-control shipping_id input-rounded f-s-14" required>
                  <option value>Select Shipping line</option>
                  <option
                    v-for="shipping in systemShippinglines"
                    :value="shipping.id"
                    :key="shipping.id"
                  >{{ shipping.shipping_name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label>
                  Clearing agent
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control clearing_agent input-rounded f-s-14"
                  placeholder="clearing agent"
                  value="DAVKIT ENTERPRISES"
                  required
                />
              </div>

              <div class="form-group">
                <label>
                  Description
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control description input-rounded f-s-14"
                  placeholder="goods descriptions"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>
                  Opened date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control opened_date input-rounded f-s-14"
                  placeholder="opened date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Origin</label>
                <input
                  type="text"
                  class="form-control origin input-rounded f-s-14"
                  placeholder="origin of the cargo"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Discharge port
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control discharge_port input-rounded f-s-14"
                  placeholder="discharge port"
                  value="MSA"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Cargo quantity
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control cargo_qty input-rounded f-s-14"
                  placeholder="cargo quantity"
                  required
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>
                  Bill of landing
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control bill_landing input-rounded f-s-14"
                  placeholder="bill of landing"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Route
                  <span class="text-danger">*</span>
                </label>
                <select name="file_mov" class="form-control file_route input-rounded f-s-14">
                  <option value>Select route</option>
                  <option value="TRANSIT" selected="selected">TRANSIT</option>
                  <option value="LOCAL">LOCAL</option>
                  <option value="TRANSPORT">TRANSPORT</option>
                  <option value="SEA EXPORT">SEA EXPORT</option>
                  <option value="AIR IMPORT">AIR IMPORT</option>
                  <option value="AIR EXPORT">AIR EXPORT</option>
                </select>
              </div>
              <div class="form-group">
                <label>
                  Destination
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control destination input-rounded f-s-14"
                  placeholder="destination of cargo"
                  required
                />
              </div>
              <div class="form-group">
                <label>
                  Vessel
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control vessel input-rounded f-s-14"
                  placeholder="vessel"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingFileopening btn-rounded">
            <i class="fa fa-plus"></i> create file
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingFileopeningLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Customer.length === 0) {
      router.push("/managecustomers");
    }
    this.loadShippinglines();
    this.loadFileopening();
  },
  computed: {
    ...mapGetters(["systemShippinglines", "Customer", "Filenumber"])
  },
  methods: {
    ...mapActions(["loadShippinglines", "newFile", "loadFileopening"])
    // onImageChange(e) {
    //   let files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) return;
    //   this.createImage(files[0]);
    // },
    // createImage(file) {
    //   let reader = new FileReader();
    //   let vm = this;
    //   reader.onload = e => {
    //     vm.image = e.target.result;
    //   };
    //   reader.readAsDataURL(file);
    // }
  }
};
</script>
<style scoped>
.creatingFileopeningLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/fileopenings/fileopening.vue